import { render } from "./EditFacility.vue?vue&type=template&id=4a532948"
import script from "./EditFacility.vue?vue&type=script&lang=js"
export * from "./EditFacility.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__